export const downloadDocument = async (source, filename) => {
  const resolved = await source;
  const data = resolved?.data ?? resolved;

  let blob;
  if (data instanceof Blob) {
    blob = data;
  } else if (data instanceof ArrayBuffer) {
    const contentType = resolved?.headers?.['content-type'];
    if (!contentType) {
      throw new Error('Missing Content-Type header for downloaded document.');
    }
    blob = new Blob([data], { type: contentType });
  } else {
    throw new Error('Data is not in the expected format.');
  }

  const blobUrl = window.URL.createObjectURL(blob);
  try {
    const a = document.createElement('a');
    a.href = blobUrl;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  } finally {
    window.URL.revokeObjectURL(blobUrl);
  }
};
